<template>
    <div class="min-vh-100">
        <!-- Barre de crédits -->
        <div class="">
            <div class="content">
                <div class="d-flex justify-content-end">
                    <div class="p-3 rounded">
                        <div class="row align-items-center">
                            <!-- Colonne pour le bouton -->
                            <div class="col-auto px-2">
                                <base-button type="info" @click="openTokenModal">
                                    Générer un token API
                                </base-button>
                            </div>
                            <!-- Colonne pour le texte -->
                            <div class="col-auto px-2">
                                <div class="text-white">
                                    Crédits disponibles :
                                    <b style="font-size: 16px">{{ credits }}</b>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <card class="content py-4" v-if="!showResult">
            <!-- <div
                class="row w-100 d-flex justify-content-center align-items-center p-2"
                style="min-height: 300px"
                v-if="isLoading"
            >
                <div>
                    <h4
                        class="h-100 d-flex justify-content-between align-items-center"
                    >
                        <i class="fas fa-spinner fa-spin px-2"></i> Analyse en
                        cours ...
                    </h4>
                </div>
            </div> -->
            <!-- <div v-if="!isLoading">
                <AnalysisStep  />
            </div> -->
            <!-- <div v-if="isLoading">
                <AnalysisStep :isLoadingComplete="isStepComplete" />
            </div> -->
            <AnalysisStep
                v-if="isLoading"
                :isLoadingComplete="isStepComplete"
                @analysisCompleted="hideAnalysis"
            />
            <div class="row" v-else>
                <div class="image-container text-center"></div>
                <div
                    class="row w-100 d-flex justify-content-center align-items-center p-2"
                >
                    <div>
                        <div
                            class="d-flex justify-content-center align-items-center"
                            style="
                                background-color: #3cb371;
                                width: 60px;
                                height: 60px;
                                border-radius: 50%;
                            "
                        >
                            <img
                                src="/img/weedo-it-logo-blanc.png"
                                alt="Logo Weedo"
                                class="img-fluid"
                                style="
                                    max-height: 40px;
                                    width: 40px;
                                    object-fit: contain;
                                "
                            />
                        </div>
                        <!-- <div v-loading="true" class="h-100 d-flex justify-content-between align-items-center"></div> -->
                    </div>
                </div>
                <div class="col-12">
                    <div class="card card-chart">
                        <div class="card-header py-0">
                            <div class="row mb-0 pb-0">
                                <div class="col-12 text-left">
                                    <h2 class="card-title">
                                        Vérification d'identité
                                    </h2>
                                    <h4 class="card-title text-muted">
                                        <b>
                                            Veuillez saisir vos informations
                                            pour l'analyse</b
                                        >
                                    </h4>
                                </div>
                                <!-- <div class="col-12">
                                    <div class="row flex-column">
                                        <div class="col">
                                            <base-input
                                                name="lastName"
                                                v-validate="'required'"
                                                :error="getError('lastName')"
                                                v-model="formData.nom"
                                                placeholder="Nom de famille"
                                                addon-left-icon="tim-icons icon-single-02"
                                                required
                                            >
                                            </base-input>
                                        </div>
                                        <div class="col">
                                            <base-input
                                                name="email"
                                                v-validate="'required|email'"
                                                :error="getError('email')"
                                                v-model="formData.email"
                                                type="email"
                                                placeholder="Email"
                                                addon-left-icon="tim-icons icon-email-85"
                                                required
                                            >
                                            </base-input>
                                        </div>
                                        <div class="col">
                                            <vue-phone-number-input
                                                name="mobile"
                                                valid-color="#54347C"
                                                :no-example="true"
                                                :dark="true"
                                                :border-radius="8"
                                                dark-color="#000"
                                                error-color="#ec250d"
                                                :only-countries="
                                                    this.countrysCode
                                                "
                                                :translations="{
                                                    countrySelectorLabel:
                                                        $t(
                                                            'inputs.CountryCode'
                                                        ),
                                                    phoneNumberLabel:
                                                        $t(
                                                            'inputs.PhoneNumber'
                                                        ),
                                                }"
                                                color="#988fc3"
                                                :error="showErrorMobile"
                                                v-validate="'required'"
                                                v-model="formData.phone"
                                                @update="onUpdate"
                                            >
                                            </vue-phone-number-input>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="col-12">
                                    <div class="card pt-3">
                                        <div
                                            class="row d-flex flex-column justify-content-center align-items-center"
                                        >
                                            <div class="col-12 col-md-8">
                                                <base-input
                                                    name="nom"
                                                    v-validate="'required'"
                                                    :error="getError('nom')"
                                                    v-model="formData.nom"
                                                    placeholder="Nom"
                                                    addon-left-icon="tim-icons icon-single-02"
                                                    required
                                                ></base-input>
                                                <base-input
                                                    name="prenom"
                                                    v-validate="'required'"
                                                    :error="getError('prenom')"
                                                    v-model="formData.prenom"
                                                    placeholder="Prénom"
                                                    addon-left-icon="tim-icons icon-single-02"
                                                    required
                                                ></base-input>
                                            </div>
                                            <div class="col-12 col-md-8">
                                                <base-input
                                                    name="email"
                                                    v-validate="
                                                        'required|email'
                                                    "
                                                    :error="getError('email')"
                                                    v-model="formData.email"
                                                    type="email"
                                                    placeholder="Email"
                                                    addon-left-icon="tim-icons icon-email-85"
                                                    required
                                                ></base-input>
                                            </div>
                                            <div class="col-12 col-md-8">
                                                <vue-phone-number-input
                                                    name="mobile"
                                                    valid-color="#54347C"
                                                    :no-example="true"
                                                    :dark="true"
                                                    :border-radius="8"
                                                    dark-color="#000"
                                                    error-color="#ec250d"
                                                    :only-countries="
                                                        countrysCode
                                                    "
                                                    :translations="{
                                                        countrySelectorLabel:
                                                            $t(
                                                                'inputs.CountryCode'
                                                            ),
                                                        phoneNumberLabel: $t(
                                                            'inputs.PhoneNumberWeedoTrust'
                                                        ),
                                                    }"
                                                    color="#988fc3"
                                                    :error="showErrorMobile"
                                                    v-validate="'required'"
                                                    v-model="phone"
                                                    @update="onUpdate"
                                                ></vue-phone-number-input>
                                                <label
                                                    v-if="showErrorMobile"
                                                    class="error"
                                                    style="color: #ec250d"
                                                    >{{ errorMessage }}</label
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-10 justify-content-center mt-0">
                                <base-button type="info" @click="validate"
                                    ><i class="tim-icons icon-zoom-split"></i>
                                    Lancer la vérification</base-button
                                >
                            </div>
                        </div>
                    </div>
                    <div v-if="erreur">
                        <base-alert type="default">
                            <span>
                                <template> {{ erreur }} </template>
                            </span>
                        </base-alert>
                    </div>
                </div>
            </div>

            <!-- Remplacer le "test" dans v-if="!showResult" par ce code -->
            <div class="max-w-xl mx-auto p-6 rounded-xl shadow-sm">
                <!--  <base-alert type="default" dismissible v-show="errors.length">
                    <li v-for="(error, index) in errors" :key="index">
                        {{ error }}
                    </li>
                </base-alert> -->

                <!-- Étapes de vérification -->
                <div
                    v-if="verificationState === 'verifying'"
                    class="mt-6 space-y-4"
                >
                    <div class="text-center mb-8">
                        <h2 class="text-xl font-semibold text-gray-800 mb-2">
                            Analyse en cours
                        </h2>
                        <p class="text-gray-600">
                            Veuillez patienter pendant que nous vérifions vos
                            informations
                        </p>
                    </div>

                    <div
                        v-for="(step, key) in verificationSteps"
                        :key="key"
                        class="flex items-center gap-3 p-4 bg-white rounded-lg shadow-sm"
                    >
                        <i :class="getStepIcon(step.status)"></i>
                        <span class="text-gray-700">{{ step.message }}</span>
                    </div>
                </div>

                <!-- Message de succès -->
                <div
                    v-if="verificationState === 'success'"
                    class="mt-6 text-center"
                >
                    <div class="mb-6">
                        <i
                            class="tim-icons icon-check-2 text-success animate-pulse"
                            style="font-size: 3rem"
                        ></i>
                    </div>
                    <h2 class="text-2xl font-bold text-gray-800 mb-2">
                        Vérification terminée
                    </h2>
                    <p class="text-gray-600">Génération de votre rapport...</p>
                </div>
            </div>
        </card>

        <div class="content py-4" v-else>
            <div class="row">
                <!-- Contenu principal -->
                <div class="col-lg-8 d-flex">
                    <!-- Score Global -->
                    <!-- <div :class="['card p-3 d-flex', scoreClass.borderColor]"> -->
                    <div
                        :class="[
                            'card p-3 d-flex',
                            scorePercentage === 0
                                ? 'bg-danger-custom'
                                : scoreClass.borderColor,
                        ]"
                    >
                        <div :class="['card-body', scoreClass.bgColor]">
                            <div class="row align-items-center mb-4">
                                <div class="col">
                                    <div
                                        :class="[
                                            'display-4 font-weight-bold mb-1 text-white',
                                            scoreClass.textColor,
                                        ]"
                                    >
                                        {{ scoreClass.grade }}
                                    </div>
                                    <div class="h3 text-white">
                                        {{ scoreClass.label }}
                                    </div>
                                </div>
                                <div class="col text-right">
                                    <div
                                        class="display-4 font-weight-bold text-white"
                                    >
                                        {{ scorePercentage }}
                                    </div>
                                    <div
                                        :class="[
                                            'h5 mb-0',
                                            scoreClass.textColor,
                                        ]"
                                    >
                                        points sur 100
                                    </div>
                                </div>
                            </div>
                            <div class="progress" style="height: 0.75rem">
                                <div
                                    :class="[
                                        'progress-bar',
                                        scoreClass.progressColor,
                                    ]"
                                    :style="{ width: scorePercentage + '%' }"
                                    role="progressbar"
                                    :aria-valuenow="scorePercentage"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                ></div>
                            </div>
                        </div>
                    </div>

                    <!-- Détails des scores -->
                    <!-- <div>
                        <div
                            class="card mb-3 p-2"
                            v-for="(item, index) in scoreDetails"
                            :key="index"
                        >
                            <div class="card-body">
                                <div
                                    class="d-flex justify-content-between align-items-center mb-3"
                                >
                                    <div>
                                        <h4 class="mb-0">{{ item.title }}</h4>
                                        <p class="mb-0 text-muted">
                                            {{ item.data.status }}
                                        </p>
                                    </div>
                                    <div class="text-right">
                                        <div class="h3 my-2 text-white">
                                            {{ item.data.score }}
                                        </div>
                                        <p class="text-white">
                                            /
                                            {{ item.data.maxScore }}
                                            points
                                        </p>
                                    </div>
                                </div>
                                <div class="progress" style="height: 0.5rem">
                                    <div
                                        class="progress-bar bg-success-progress-bar"
                                        :style="{
                                            width:
                                                (item.data.score /
                                                    item.data.maxScore) *
                                                    100 +
                                                '%',
                                        }"
                                        role="progressbar"
                                        :aria-valuenow="item.data.score"
                                        :aria-valuemax="item.data.maxScore"
                                        aria-valuemin="0"
                                    ></div>
                                </div>
                                <p class="text-left mt-2 text-muted">
                                    <b
                                        >{{
                                            (
                                                (item.data.score /
                                                    item.data.maxScore) *
                                                100
                                            ).toFixed(2)
                                        }}%</b
                                    >
                                </p>
                            </div>
                        </div>
                    </div> -->
                </div>

                <!-- Sidebar Profile -->
                <div class="col-lg-4 d-flex">
                    <div
                        class="card d-flex p-3 position-sticky"
                        style="top: 1rem"
                    >
                        <div class="card-body">
                            <!-- Container pour l'image et les boutons -->
                            <div
                                class="position-relative mb-4"
                                style="width: fit-content"
                            >
                                <!-- Image -->
                                <img
                                    :src="
                                        currentImage || '/img/placeholder.jpg'
                                    "
                                    class="rounded-circle"
                                    alt="Profile"
                                    style="
                                        width: 70px;
                                        height: 70px;
                                        object-fit: cover;
                                    "
                                />
                                <!-- Boutons réseaux sociaux en bas à droite -->
                                <div
                                    class="position-absolute"
                                    style="bottom: -15px; left: 70px"
                                >
                                    <div class="d-flex gap-1">
                                        <button
                                            v-if="images.whatsapp"
                                            title="whatsapp"
                                            :class="['btn btn-sm rounded-circle', currentNetwork === 'whatsapp' ? 'btn-info' : 'btn-primary']"
                                            style="
                                                width: 30px;
                                                height: 30px;
                                                padding: 0;
                                            "
                                            @click="switchImage('whatsapp')"
                                        >
                                            <i
                                                class="fab fa-whatsapp text-white"
                                                style="font-size: 16px"
                                            ></i>
                                        </button>
                                        <button
                                            v-if="images.skype"
                                            title="Skype"
                                            :class="['btn btn-sm rounded-circle', currentNetwork === 'skype' ? 'btn-info' : 'btn-primary']"
                                            style="
                                                width: 30px;
                                                height: 30px;
                                                padding: 0;
                                            "
                                            @click="switchImage('skype')"
                                        >
                                            <i
                                                class="fab fa-skype text-white"
                                                style="font-size: 16px"
                                            ></i>
                                        </button>
                                        <button
                                            v-if="images.telegram"
                                            title="Telegram"
                                            :class="['btn btn-sm rounded-circle', currentNetwork === 'telegram' ? 'btn-info' : 'btn-primary']"
                                            style="
                                                width: 30px;
                                                height: 30px;
                                                padding: 0;
                                            "
                                            @click="switchImage('telegram')"
                                        >
                                            <i
                                                class="fab fa-telegram-plane text-white"
                                                style="font-size: 16px"
                                            ></i>
                                        </button>
                                        <button
                                            v-if="images.google"
                                            title="Google"
                                            :class="['btn btn-sm rounded-circle', currentNetwork === 'google' ? 'btn-info' : 'btn-primary']"
                                            style="
                                                width: 30px;
                                                height: 30px;
                                                padding: 0;
                                            "
                                            @click="switchImage('google')"
                                        >
                                            <i
                                                class="fab fa-google text-white"
                                                style="font-size: 16px"
                                            ></i>
                                        </button>
                                        <button
                                            v-if="images.search"
                                            title="Recherche"
                                            :class="['btn btn-sm rounded-circle', currentNetwork === 'search' ? 'btn-info' : 'btn-primary']"
                                            style="
                                                width: 30px;
                                                height: 30px;
                                                padding: 0;
                                            "
                                            @click="switchImage('search')"
                                        >
                                            <i
                                                class="fas fa-magnifying-glass text-white"
                                                style="font-size: 16px"
                                            ></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="border-bottom pb-3 mb-3">
                                <h3 class="mb-1 text-uppercase">
                                    {{ verificationData.verifiedProfile.nom }} {{ verificationData.verifiedProfile.prenom }}
                                </h3>
                                <p class="text-muted">
                                    Vérifié le
                                    {{
                                        verificationData.verifiedProfile
                                            .verificationDate
                                    }}
                                </p>
                            </div>

                            <div class="mb-4">
                                <div class="mb-3">
                                    <h4 class="text-white d-block mb-1">
                                        Email
                                    </h4>
                                    <p class="text-white">
                                        {{
                                            verificationData.verifiedProfile
                                                .email
                                        }}
                                    </p>
                                </div>
                                <div class="mb-3">
                                    <h4 class="d-block mb-1">Téléphone</h4>
                                    <div>
                                        <div class="d-flex align-items-center mb-1">
                                            <div class="mr-2 text-white">
                                                {{verificationData.verifiedProfile.phone}}
                                            </div>
                                            <a :href="'tel:' + verificationData.verifiedProfile.phone" class="btn btn-link p-0 mr-2 btn-danger" title="Appeler">
                                                <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.98.98 0 0 0-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02c-.37-1.11-.56-2.3-.56-3.53c0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99C3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                                                </svg>
                                            </a>
                                            <a :href="'whatsapp://send?phone=' + verificationData.verifiedProfile.phone.replace(/[+\s]/g, '')" class="btn btn-link p-0" title="WhatsApp" style="color: #25d366">
                                                <svg width="16" height="16" fill="currentColor" viewBox="0 0 448 512">
                                                    <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
                                                </svg>
                                            </a>
                                        </div>
                                        <div class="text-muted text-sm">
                                            {{verificationData.verifiedProfile.operator }}
                                        </div>
                                    </div>
                                </div>
                                <!-- <div>
                                    <h4 class="d-block mb-1">ID Client</h4>
                                    <p class="text-white">{{
                                                verificationData.verifiedProfile
                                                    .idClient
                                            }}</p>
                                </div> -->
                            </div>

                            <div class="border-top pt-3">
                                <div
                                    class="row mb-10 justify-content-center mt-0"
                                >
                                    <base-button type="info" @click="newVerif"
                                        ><i
                                            class="tim-icons icon-zoom-split"
                                        ></i>
                                        Nouvelle vérification</base-button
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <center class="mt-4">
                <base-button
                    v-if="showEvaluation"
                   @click="evaluate"
                    native-type="submit"
                    class="text-uppercase fw-bold"
                    type="primary"
                    style="padding: 12px 30px;"
                >
                    <i class="fas fa-star mr-2"></i>
                    Soumettre une évaluation
                </base-button>
            </center>
        </div>

        <!-- modal evaluation -->
        <Modal_selfEvent
            :show.sync="showModal"
            body-classes="p-0"
            modalClasses="modal-dialog modal-dialog-centered"
            data-keyboard="false"
            data-backdrop="static"
            class="modal-listbase"
        >
            <card
                type="secondary"
                header-classes="bg-white pb-6"
                body-classes="px-lg-6 py-lg-6"
                class="border-0 mb-0 fixed-height"
            >
                <base-button
                    style="float: right"
                    @click.native="closeModal()"
                    class="like btn-link"
                    type="danger"
                    size="sm"
                    icon
                >
                    <i class="tim-icons icon-simple-remove"></i>
                </base-button>
                <div class="card">
                    <!-- <h4 class="card-title">
                        Évaluation de la conformité de vérification
                    </h4> -->
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <form @submit.prevent="validateEvaluation">
                                    <!-- Section de notation -->
                                    <div class="rating-section px-4 rounded">
                                        <label class="form-control-label h5 mb-3">
                                            Quelle note donneriez-vous à la précision de cette vérification ?
                                        </label>
                                        <div class="text-center">
                                            <el-rate
                                                v-model="evaluations.rating"
                                                :colors="['#ffd700', '#ffd700', '#ffd700']"
                                                show-score
                                                text-color="#ff9900"
                                                score-template="{value}/5"
                                                :size="30"
                                                style="transform: scale(1.5); margin: 15px 0;"
                                            >
                                            </el-rate>
                                            <div class="rating-help text-muted mt-2">
                                                <small>5 étoiles = Excellent | 1 étoile = À améliorer</small>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Ajout du champ commentaire -->
                                    <div class="form-row">
                                        <div class="col">
                                            <div class="feedback-section mt-3">
                                                <textarea
                                                    class="form-control"
                                                    placeholder="Décrivez ce qui était incorrect ou à améliorer."
                                                    v-model="evaluations.comment"
                                                    rows="5"
                                                    style="min-height: 150px; resize: vertical; border-radius: 8px; padding: 15px;"
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <center class="mt-2">
                                        <base-button
                                            v-if="!loading"
                                            native-type="submit"
                                            type="info"
                                        >ENVOYER
                                        </base-button>
                                        <base-button v-else type="info" loading
                                        >ENVOYER</base-button>
                                    </center>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </card>
        </Modal_selfEvent>

        <!-- modal Token -->
        <Modal_selfEvent
            :show.sync="showTokenModal"
            body-classes="p-0"
            modalClasses="modal-dialog modal-dialog-centered"
            data-keyboard="false"
            data-backdrop="static"
            class="modal-listbase"
        >
            <card
                type="secondary"
                header-classes="bg-white pb-6"
                body-classes="p-3"
                class="border-0 mb-0 fixed-height-token"
            >
                <base-button
                    style="float: right"
                    @click.native="closeTokenModal()"
                    class="like btn-link"
                    type="danger"
                    size="sm"
                    icon
                >
                    <i class="tim-icons icon-simple-remove"></i>
                </base-button>
                <div class="card">
                    <!-- <h4 class="card-title">
                        Évaluation de la conformité de vérification
                    </h4> -->
                    <div class="card-body card-token">
                        <div class="row" v-if="!loadingTokenApi">
                            <div class="col" v-if="erreurTokenApi">
                                <base-alert type="default">
                                    <span>
                                        <template> {{ erreurTokenApi }} </template>
                                    </span>
                                </base-alert>
                            </div>
                            <div class="col" v-else>
                                <!-- Conteneur pour le token et le bouton -->
                                <div style="display: flex; flex-direction: column; height: 100%;">
                                    <div class="mb-3 ">
                                       <b class="text-uppercase"> ID Utilisateur : </b> <span style="font-size: 1rem;">   <b> {{ userId }} </b>  </span>
                                    </div>
                                    <!-- Token -->
                                    <div style="flex: 1; word-break: break-all;">
                                        <b class="text-uppercase">Token Api : </b>{{ token_api }}
                                    </div>
                                    <!-- Bouton de copie centré en bas -->
                                    <div style="text-align: center;" class="mb-0 mt-2">
                                        <base-button type="info" @click="copyToken">
                                            <i class="fas fa-copy"></i> Copier token
                                        </base-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Affichage du loading lorsque loadingTokenApi est true -->
                        <div v-else class="d-flex justify-content-center align-items-center" style="height: 180px;">
                            <div class="text-center">
                                <i class="fas fa-spinner fa-spin px-2"></i> Chargement en cours ...
                            </div>
                        </div>
                    </div>
                </div>
            </card>
        </Modal_selfEvent>
         <!-- END modal Token -->
    </div>
</template>

<script>
import moment from "moment";
import { BasePagination, Modal, BaseAlert } from "src/components";
import AnalysisStep from "./Process/SecuritySteps.vue";
import fab from "vue-fab";
import Modal_selfEvent from "src/components/Modal_selfEvent";
import {Select, Option, Rate } from 'element-ui'

moment.locale("fr");
export default {
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [Rate.name]: Rate,
        BaseAlert,
        AnalysisStep,
        fab,
        Modal_selfEvent,
    },
    name: "ResultPage",
    mounted() {
        this.trackConnections();
        this.getSoldeCredit();
    },
    data() {
        return {
            userId:null,
            erreurTokenApi:"",
            loadingTokenApi:true,
            token_api:"",
            showTokenModal:false,
            showEvaluation:true,
            evaluations: {
                Status: '',
                ListStatus: [],
                rating: 0,
                comment: '',
            },
            loading: false,
            showModal: false,
            isSuccess: false,
            isStepComplete: false,
            erreur: "",
            scorePercentage: 0,
            isLoading: false,
            phone: "",
            formatPhone: "",
            errorMessage: "",
            countrysCode: ["FR"],
            showErrorMobile: false,
            showResult: false,
            verificationState: "input",
            formData: {
                nom: "",
                prenom: "",
                email: "",
                phone: "",
            },
            errors1: [],
            verificationSteps: {
                identity: {
                    status: "pending",
                    message: "Vérification de l'identité",
                },
                email: { status: "pending", message: "Validation de l'email" },
                phone: { status: "pending", message: "Vérification du numéro" },
                risk: { status: "pending", message: "Analyse des risques" },
            },
            credits: 0,
            images: {
                /* whatsapp: "https://eu-west-1-807149116723-wa-profile-production.s3.eu-west-1.amazonaws.com/db951577/bb53/4a5a/b296/ccd6b336eaed/3b80c148-6674-41f6-9a66-a43d81cfc55f.jpg", // URL de l'image WhatsApp
                facebook: "https://eu-west-1-807149116723-telegram-production.s3.eu-west-1.amazonaws.com/f084e529/ff39/4c3d/a86e/113c79c63c64.jpg", // URL de l'image Facebook
                telegram: null, // URL de l'image Telegram */
            },
            currentImage: null,
            verificationData: {
                verifiedProfile: {
                    firstName: "Lidy",
                    lastName: "Aviet",
                    email: "lidy.aviet@orange.fr",
                    phone: "+33 613209133",
                    verificationDate: "30 Jan 2025, 14:23",
                },
                scores: {
                    email: {
                        score: 30,
                        maxScore: 35,
                        status: "Email vérifié et actif",
                    },
                    phone: {
                        score: 28,
                        maxScore: 35,
                        status: "Numéro actif et vérifié",
                    },
                    botDetection: {
                        score: 15,
                        maxScore: 20,
                        status: "Comportement humain",
                    },
                    activity: {
                        score: 8,
                        maxScore: 10,
                        status: "Activité normale",
                    },
                },
            },
            resultData:null,
            currentNetwork: null
        };
    },
    computed: {
        scoreDetails() {
            const { email, phone, botDetection, activity } =
                this.verificationData.scores;
            return [
                { title: "Email", data: email },
                { title: "Téléphone", data: phone },
                { title: "Détection Bot/Humain", data: botDetection },
                { title: "Activité", data: activity },
            ];
        },
        totalScore() {
            return Object.values(this.verificationData.scores).reduce(
                (acc, curr) => acc + curr.score,
                0
            );
        },
        maxTotalScore() {
            return Object.values(this.verificationData.scores).reduce(
                (acc, curr) => acc + curr.maxScore,
                0
            );
        },
        /* scorePercentage() {
            return Math.round((this.totalScore / this.maxTotalScore) * 100);
        }, */
        scoreClass() {
            if (this.scorePercentage > 70) {
                return {
                    grade: "A",
                    label: "Premium",
                    bgColor: "",
                    textColor: "text-white",
                    borderColor: "",
                    progressColor: "bg-success-custom",
                };
            }
            if (this.scorePercentage >= 45 && this.scorePercentage <= 70) {
                return {
                    grade: "B",
                    label: "Standard",
                    bgColor: "",
                    textColor: "text-white",
                    borderColor: "",
                    progressColor: "bg-warning-custom",
                };
            }
            return {
                grade: "C",
                label: "Risque",
                bgColor: "",
                textColor: "text-white",
                borderColor: "",
                progressColor: "bg-danger-custom",
            };
        },
    },
    methods: {
        openTokenModal(){
            this.loadingTokenApi = true;
            this.showTokenModal = true;
            this.userId = JSON.parse(localStorage.getItem("utilisateur")).id;
            this.generateApiToken();
        },
        closeTokenModal(){
            this.loadingTokenApi = false;
            this.erreurTokenApi = ""
            this.showTokenModal = false;
        },
        copyToken(){
            const tempInput = document.createElement("textarea");
            tempInput.value = this.token_api; // Définit la valeur du token
            document.body.appendChild(tempInput); // Ajoute l'élément au DOM
            tempInput.select(); // Sélectionne le texte
            document.execCommand("copy"); // Copie le texte sélectionné
            document.body.removeChild(tempInput);
            this.$notify({
                    type: "success",
                    verticalAlign: "top",
                    horizontalAlign: "right",
                    message:
                        "Token copié dans le presse papier avec succèss.",
                });
        },
        generateApiToken(){
            let accessToken = localStorage.getItem("token_jwt");
            this.axios
                .get(
                    `https://api-auth-plf.wee-do-it.net/api/v1/trust/authentification/generate_token/${this.userId}`,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            authorization: `Bearer ${accessToken}`,
                        },
                    }
                )
                .then((response) => {
                    if (response.data && response.data.success) {
                        this.token_api = response.data.token;
                    } else {
                        this.erreurTokenApi = "Échec de la génération du token.";
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.erreurTokenApi =
                        error.response &&
                        error.response.data &&
                        error.response.data.message
                        ? error.response.data.message
                        : error.message || "Une Erreur est survenue";
                })
                .finally(() => {
                    this.loadingTokenApi = false;
                });
        },
        validateEvaluation(){
            this.loading = true;
            let formData = new FormData();
            formData.append("id", this.resultData.id);
            //formData.append("id", 216);
            formData.append("comment", this.evaluations.comment);
            formData.append("evaluation_note", this.evaluations.rating);
            let accessToken = localStorage.getItem("token_jwt");
            this.axios
                .post(
                    "https://api-auth-plf.wee-do-it.net/api/v1/trust/add_evaluation",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            authorization: `Bearer ${accessToken}`,
                        },
                    }
                )
                .then((response) => {
                    //console.log("response: ", response.data);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                    this.showEvaluation = false;
                    this.closeModal();
                });
        },
        evaluate() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.evaluations.comment = ''
            this.evaluations.rating = 0
        },
        setDefaultImage() {
            // Recherche de la première image disponible
            const firstAvailableImage = Object.entries(this.images).find(
                ([key, img]) => img
            );

            this.currentImage = firstAvailableImage ? firstAvailableImage[1] : null;
            this.currentNetwork = firstAvailableImage ? firstAvailableImage[0] : null;
        },

        switchImage(socialNetwork) {
            if (this.images[socialNetwork]) {
                this.currentImage = this.images[socialNetwork];
                this.currentNetwork = socialNetwork;
            }
        },
        logError(error) {
            let errorCode =
                error.response && error.response.status
                    ? error.response.status
                    : null;
            let errorData =
                error.response && error.response.data
                    ? error.response.data
                    : error;

            // Vérifie si error.response et error.response.data existent, puis récupère message
            let errorMessage =
                error.response &&
                error.response.data &&
                error.response.data.message
                    ? error.response.data.message
                    : error.message || "Erreur inconnue";
            let formData = new FormData();
            let utilisateurId = JSON.parse(
                localStorage.getItem("utilisateur")
            ).id;
            formData.append("id_utilisateur", utilisateurId);
            formData.append("nom", this.formData.nom + " " + this.formData.prenom);
            formData.append("email", this.formData.email);
            formData.append("phone", this.formData.phone);
            formData.append("code_error", errorCode);
            formData.append("message_error", errorMessage);
            formData.append("erreur_json", JSON.stringify(errorData));
            let accessToken = localStorage.getItem("token_jwt");
            this.axios
                .post(
                    "https://api-auth-plf.wee-do-it.net/api/v1/logs_weedo_trust",
                    formData,
                    {
                        /* headers: {
                'authorization': `Bearer ${accessToken}`
                } */
                        headers: {
                            "Content-Type": "multipart/form-data",
                            authorization: `Bearer ${accessToken}`,
                        },
                    }
                )
                .then((response) => {
                    //console.log("response: ", response.data);
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        trackConnections() {
            let formData = new FormData();
            let utilisateurId = JSON.parse(
                localStorage.getItem("utilisateur")
            ).id;
            formData.append("id_utilisateur", utilisateurId);
            let accessToken = localStorage.getItem("token_jwt");
            this.axios
                .post(
                    "https://api-auth-plf.wee-do-it.net/api/v1/update_user_connection_weedo_trust",
                    formData,
                    {
                        /* headers: {
                'authorization': `Bearer ${accessToken}`
                } */
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            authorization: `Bearer ${accessToken}`,
                        },
                    }
                )
                .then((response) => {
                    //console.log("response: ", response);
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        hideAnalysis() {
            this.isLoading = false;
            if (this.isSuccess) {
                this.showResult = true;
            }
        },
        sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },
        newVerif() {
            this.isSuccess = false;
            this.phone = "";
            this.formData = {
                nom: "",
                prenom: "",
                email: "",
                phone: "",
            };
            this.showResult = false;
            this.isLoading = false;
            this.erreur = "";
        },
        onUpdate(payload) {
            this.isValid = payload.isValid;
            this.formatPhone = payload.nationalNumber;
            //console.log(payload)
        },
        /* formatPhone(event) {
            // Supprime tout caractère non numérique
            this.formData.phone = event.target.value.replace(/\D/g, "");
        }, */
        // ... vos méthodes existantes ...
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        getStepIcon(status) {
            const icons = {
                pending: "tim-icons icon-refresh-02 animate-spin text-info",
                complete: "tim-icons icon-check-2 text-success",
                error: "tim-icons icon-simple-remove text-danger",
            };
            return icons[status];
        },

        /* async handleSubmit() {
            //this.errors = [];
            try {
                await this.$validator.validateAll();
                if (this.errors.length === 0) {
                    this.verificationState = "verifying";
                    await this.simulateVerification();
                }
            } catch (error) {
                this.errors.push({ message: error.message });
            }
        }, */

        validate() {
            this.showErrorMobile = false;
            this.isStepComplete = false;
            this.showEvaluation = true;
            this.images = {}
            this.errorMessage = "";
            this.$validator.validateAll().then((isValid) => {
                if (this.errors.items.length > 0) {
                    this.showErrorMobile = true;
                    this.errorMessage = this.errors.first("mobile");
                }
                if (isValid) {
                    if (!this.isValid) {
                        this.showErrorMobile = true;
                        this.errorMessage = "Numéro de téléphone invalide";
                    } else {
                        this.isLoading = true;
                        this.getVerification();
                    }
                }
            });
        },
        getVerification() {
            let value = this.formatPhone;
            if (value.startsWith("0")) {
                this.formData.phone = value.slice(1);
            } else {
                this.formData.phone = value;
            }
            let formData = new FormData();
            formData.append("nom", this.formData.nom.trim());
            formData.append("prenom", this.formData.prenom.trim());
            formData.append("email", this.formData.email.trim());
            formData.append("phone", this.formData.phone);
            formData.append("id_user", JSON.parse(localStorage.getItem('utilisateur')).id);
            let accessToken = localStorage.getItem("token_jwt");
            this.axios
                .post(
                    "https://apileadmarket.wee-do-it.net/api/trust/verify",
                    formData,
                    {
                        /* headers: {
                'authorization': `Bearer ${accessToken}`
                } */
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            authorization: `Bearer ${accessToken}`,
                        },
                    }
                )
                .then((response) => {
                    //console.log("response: ", response);
                    //if (response.data.success) {
                    if (response.data && response.data.success) {
                        this.isSuccess = true;
                        let result = response.data.data.verification;
                        this.resultData = response.data.data.verification;
                        this.scorePercentage = Math.round(
                            (result.score_total / 100) * 100
                        );
                        this.verificationData = {
                            verifiedProfile: {
                                nom: this.formData.nom,
                                prenom: this.formData.prenom,
                                email: this.formData.email,
                                phone: "+33" + this.formData.phone,
                                operator:result.current_network,
                                verificationDate: moment(
                                    result.verification_date
                                ).format("DD MMM YYYY"),
                            },
                            scores: {
                                email: {
                                    score: result.score_email,
                                    maxScore: 35,
                                    status: "Email vérifié et actif",
                                },
                                phone: {
                                    score: result.score_phone,
                                    maxScore: 35,
                                    status: "Numéro actif et vérifié",
                                },
                                botDetection: {
                                    score: result.score_bot_detection,
                                    maxScore: 20,
                                    status: "Comportement humain",
                                },
                                activity: {
                                    score: result.score_activity,
                                    maxScore: 10,
                                    status: "Activité normale",
                                },
                            },
                        };
                        //this.showResult = true;
                        this.images = {
                            whatsapp: result.whatsapp_image,
                            telegram: result.telegram_image,
                            google: result.google_profile_picture,
                            skype: result.skype_profile_picture
                                ? result.skype_profile_picture
                                : result.skype_profile_picture_email,
                            search: result.avatar,
                        };
                        this.setDefaultImage();
                        this.credits = response.data.data.current_balance;
                        this.isStepComplete = true;
                    } else {
                        this.isLoading = false;
                        this.erreur = "La vérification a échoué !";
                        console.error("La vérification a échoué !");
                    }
                })
                .catch((error) => {
                    console.log("error");
                    if (error.response && error.response.status === 403) {
                        this.erreur =
                            "Solde insuffisant. Veuillez recharger votre compte.";
                        // Ajoute ici ton action (ex: afficher un message d'erreur)
                    } else {
                        this.erreur =
                            "Le service est en maintenance. Veuillez réessayer plus tard.";
                    }
                    this.isLoading = false;
                    console.error(error);
                    this.logError(error);
                });
        },
        getSoldeCredit() {
            let utilisateurId = JSON.parse(
                localStorage.getItem("utilisateur")
            ).id;
            let accessToken = localStorage.getItem("token_jwt");
            this.axios
                //.post("http://127.0.0.1:8000/api/validation_numeros_telephones",formData,{
                .get(
                    `https://api-auth-plf.wee-do-it.net/api/v1/trust/balance/${utilisateurId}`,
                    {
                        /* headers: {
                'authorization': `Bearer ${accessToken}`
                } */
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            authorization: `Bearer ${accessToken}`,
                        },
                    }
                )
                .then((response) => {
                    if (response.data.success) {
                        //console.log(response)
                        this.credits = response.data.data.balance;
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        async simulateVerification() {
            const steps = ["identity", "email", "phone", "risk"];
            const delays = [1500, 1000, 1200, 1800];

            for (let i = 0; i < steps.length; i++) {
                await new Promise((resolve) => setTimeout(resolve, delays[i]));
                this.$set(
                    this.verificationSteps[steps[i]],
                    "status",
                    "complete"
                );
            }

            await new Promise((resolve) => setTimeout(resolve, 1000));
            this.verificationState = "success";
            await new Promise((resolve) => setTimeout(resolve, 1500));

            this.showResult = true;
        },
    },
};
</script>

<style scoped>
.bg-success-custom {
    background: #02c74f;
}
.bg-danger-custom {
    background: #e50123;
}
.bg-warning-custom {
    background: #ede403;
}
.bg-success-progress-bar {
    background: #588bbd;
}
.bg-success-progress-bar-warning {
    background: #d5af1e;
}
.vue-phone-number-input .iti__selected-flag {
    pointer-events: none; /* Désactive le clic sur le sélecteur de pays */
    opacity: 0.5; /* Facultatif, pour ajouter un effet visuel */
}
.disabled-country-selector .country-selector {
    pointer-events: none; /* Désactive les interactions */
    opacity: 0.7; /* Rend le sélecteur légèrement transparent */
}

.feedback-section textarea:focus {
    box-shadow: 0 0 0 0.2rem rgba(179, 179, 180, 0.25);
}

.feedback-section label h5 {
    color: #2c3e50;
    font-weight: 600;
}
.feedback-section textarea::placeholder {
    color: #6c757d !important; /* text-muted color */
    font-style: italic;
    opacity: 0.7;
}
.card-token{
    padding: 15px 20px 0px 15px !important;
}
.fixed-height-token{
    min-height: 320px !important;
}
</style>
